import React from "react"
import ContentLoader from "react-content-loader"

/**
 * Loader de información para la landing page
 * @author Jhoan López <jhoanlt19@gmail.com>
 */
export const LandingPageLoader = ({count=1}) => {
  const elements = Array(count).fill("list-item-landing-loader");
  let y = 50;
  
  return (
    <ContentLoader
      height={300}
      width={500}
      speed={2}
      primaryColor="#f3f3f3"
      secondaryColor="#e0e0e0"
    >
      <rect x="90" y="19" rx="5" ry="5" width="350" height="15" />

      {
        elements.map((value, key) => {
          y += 10;
          return(
            <rect x="44" y={y} rx="5" ry="5" width="440" height="8" key={key}/>
          )
      })}

      <rect x="58" y="210" rx="5" ry="5" width="415" height="30" />
      <rect x="58" y="260" rx="5" ry="5" width="415" height="30" />
    </ContentLoader>
  )};

/**
 * loader para listas
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
export const ListLoader = ({count=1}) => {
  const elements = Array(count).fill("list-item-loader");
  let y = 0;

  return (
    <ContentLoader
      height={300}
      width={500}
      speed={2}
      primaryColor="#f3f3f3"
      secondaryColor="#e0e0e0"
    >
      {
        elements.map((value, key) => {
          y += 30;
          return(
            <rect x="10" y={y} rx="5" ry="5" width="470" height="20" key={key}/>
          )
      })}
    </ContentLoader>
  );
};

/**
 * loader para filros iniciales
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
export const FiltersLoader = ({count=1, height='250'}) => {
  const elements = Array(count).fill("list-item-loader");
  let y = 0;

  return (
    <ContentLoader
      height={300}
      width={500}
      speed={2}
      primaryColor="#f3f3f3"
      secondaryColor="#e0e0e0"
    >
      {
        elements.map((value, key) => {
          y += 30;
          return(
            <rect x="10" y={y} rx="5" ry="5" width="100%" height={height} key={key}/>
          )
      })}
    </ContentLoader>
  );
};



// WEBPACK FOOTER //
// ./src/components/commons/loaders/index.js